.infoText {
  color: var(--body-text-arrows-400);
}

#content-control-traffic-scan-text {
  max-width: 640px;
}

#content-control-traffic-scan-email-incoming-and-outgoing-mapi-field-info-box {
  max-width: 597px;
}
